import type { FilterCancellationProps } from "@b2bportal/core-hotels";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { CheckboxGroup } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FilterCancellation.module.scss";

export const FilterCancellation = ({
  isFreeCancellationSelected,
  onChange,
  className,
}: FilterCancellationProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.FilterCancellation,
    defaultStyles
  );
  const [block] = useModuleBEM(styles, CoreHotelsComponent.FilterCancellation);
  const { t } = useI18nContext();

  const options = [
    {
      value: "true",
      label: t(
        "core-hotels.availabilityPage.filters.cancellation.freeCancellation"
      ),
    },
  ];

  return (
    <div className={clsx(className, block)}>
      <CheckboxGroup
        options={options}
        checkedOptions={isFreeCancellationSelected ? ["true"] : []}
        onOptionsChange={(value) => {
          const isFreeCancellation = value.includes("true");
          onChange(isFreeCancellation);
        }}
      />
    </div>
  );
};
